<template>
  <div class="d-flex justify-content-between nav-video">
    <router-link :to="{path: controleTopico.anterior.url}" class="btn btn-secondary"><i class="fas fa-step-backward"></i> <span class="d-none d-md-inline-block">{{ controleTopico.anterior.nome }}</span></router-link>
    <div class="float-right autoplay" id="autoplayComponent">
      <div class="custom-control custom-switch label-autoplay">
      <b-form-checkbox v-model="autoplay">Reprodução Automática</b-form-checkbox>
      </div>
     </div>
    <router-link :to="{path: controleTopico.proximo.url}" class="btn btn-secondary" v-html="proximoNome"></router-link>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ControleTopico',
  props: {
    controleTopico: Object
  },
  computed: {
    autoplay: {
      get () {
        return JSON.parse(localStorage.getItem('autoplay'))
      },
      set (value) {
        return localStorage.setItem('autoplay', value)
      }
    },
    proximoNome () {
      if (this.timer) {
        return '<span class="d-none d-md-inline-block">' + this.controleTopico.proximo.nome + '</span>' + '<i class="fas fa-step-forward"></i>' + '<br><h5 class="tempo_proximo_video">começará em ' + this.segundos + ' segundos</h5>'
      }
      return '<span class="d-none d-md-inline-block">' + this.controleTopico.proximo.nome + '</span>' + '<i class="fas fa-step-forward"></i>'
    },
    ...mapState({
      segundos: (state) => state.segundos,
      timer: (state) => state.timer
    })
  }
}
</script>

<style scoped>

</style>
